<template>
    <el-container>
      <el-header height="80px">
        <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
          <el-menu-item @click="back()">后退</el-menu-item>
          <el-menu-item index="/xihoumenIndex">首页</el-menu-item>
          <el-submenu :index="'/xihoumen/gasClamp'">
            <template slot="title">气夹实时数据</template>
            <el-menu-item index="/xihoumen/gasClamp/upstream">舟向气夹实时数据</el-menu-item>
            <el-menu-item index="/xihoumen/gasClamp/downstream">宁向气夹实时数据</el-menu-item>
          </el-submenu>
          <el-menu-item index="/xihoumen/cableClamp">索夹实时数据</el-menu-item>
          <el-submenu :index="'/xihoumen/station/main1'">
            <template slot="title">1#空气制备站(北塔)</template>
            <el-menu-item index="/xihoumen/station/main1">1#制备站主机</el-menu-item>
            <el-menu-item index="/xihoumen/station/vent1">1#制备站主机出口</el-menu-item>
            <el-menu-item index="/xihoumen/station/backup1">1#制备站备机</el-menu-item>
            <el-menu-item index="/xihoumen/station/ventBackup1">1#制备站备机出口</el-menu-item>
          </el-submenu>
          <el-submenu :index="'/xihoumen/station/main2'">
            <template slot="title">2#空气制备站(南塔)</template>
            <el-menu-item index="/xihoumen/station/main2">2#制备站主机</el-menu-item>
            <el-menu-item index="/xihoumen/station/vent2">2#制备站主机出口</el-menu-item>
            <el-menu-item index="/xihoumen/station/backup2">2#制备站备机</el-menu-item>
            <el-menu-item index="/xihoumen/station/ventBackup2">2#制备站备机出口</el-menu-item>
          </el-submenu>
          <!-- <el-submenu :index="'/xihoumen/valveClamp'">
            <template slot="title">气夹阀门</template>
            <el-menu-item index="/xihoumen/valveClamp/upstream">舟向气夹阀门</el-menu-item>
            <el-menu-item index="/xihoumen/valveClamp/downstream">宁向气夹阀门</el-menu-item>
          </el-submenu> -->
          <el-menu-item index="/xihoumen/currentDataTable?bridgeId=3d146b59-1bc6-4e89-8aa1-288e50929cbc">实时数据表</el-menu-item>
          <el-menu-item index="/xihoumen/errorRecord?bridgeId=3d146b59-1bc6-4e89-8aa1-288e50929cbc">报警记录</el-menu-item>
          <el-submenu :index="'/xihoumen/dataHistory?bridgeId=3d146b59-1bc6-4e89-8aa1-288e50929cbc&scenarioId=TBD'">
            <template slot="title">数据历史</template>
            <el-menu-item index="/xihoumen/dataHistory?bridgeId=3d146b59-1bc6-4e89-8aa1-288e50929cbc&scenarioId=TBD"> 查询数据历史 </el-menu-item>
            <el-menu-item index="/xihoumen/dataHistory?bridgeId=3d146b59-1bc6-4e89-8aa1-288e50929cbc"> 自定义数据历史 </el-menu-item>
          </el-submenu>
        </el-menu>
        <HeaderTime bridgeName="ZHOUSHAN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
      </el-header>
      <el-main class="el-main xi-hou-men">
        <router-view></router-view>
      </el-main>
    </el-container>
  </template>
    <script>
  export default {
    name: "xihoumen",
    data() {
      return {
        bridgeId: "3d146b59-1bc6-4e89-8aa1-288e50929cbc",
        envInfo: {
          envId: "36ceb849-bdbb-4d1e-bff5-dcf88a61b203",
          weather: "4c25fe31-abcc-4c47-b69f-2a2eab04cd93",
          humidity: "04093e14-a494-477e-b33f-9cd1a3555163",
          temperature: "e2869f02-0b6d-40d9-b563-673258d36c0b",
        },
        id2Path: {},
        activeIndex: "",
        historyScenarioList: [],
      };
    },
    mounted() {
      this.activeIndex = this.$route.fullPath;
  
      document.getElementById("elMenu").addEventListener(
        "mousewheel",
        (e) => {
          let scrollWidth = document.getElementById("elMenu").scrollWidth;
          let clientWidth = document.getElementById("elMenu").clientWidth;
  
          let scrollMin = 0;
          let scrollMax = scrollWidth - clientWidth;
          let step = 30;
  
          if (e.deltaY > 0) {
            document.getElementById("elMenu").scrollLeft += step;
            if (document.getElementById("elMenu").scrollLeft > scrollMax) {
              document.getElementById("elMenu").scrollLeft = scrollMax;
            }
          } else if (e.deltaY < 0) {
            document.getElementById("elMenu").scrollLeft += step * -1;
            if (document.getElementById("elMenu").scrollLeft < scrollMin) {
              document.getElementById("elMenu").scrollLeft = scrollMin;
            }
          }
        },
        true
      );
    },
    watch: {
      $route() {
        this.activeIndex = this.$route.fullPath;
      },
    },
    methods: {
      back() {
        window.history.back();
      },
      handleSelect(key) {
        if (key !== this.activeIndex) {
          this.activeIndex = key;
          this.$router.push(key);
        }
      },
    },
  };
  </script>
    
    <style lang="scss" scoped>
  .el-menu-demo {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: center;
  
    overflow-x: scroll;
  }
  
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    background: transparent;
    display: none;
  }
  </style>